const t = "styles-module__loader___zAAjD", e = {
  "months-container": "styles-module__months-container___Knde-",
  "month-title-with-navigation": "styles-module__month-title-with-navigation___HWMZw",
  "month-title-wrapper": "styles-module__month-title-wrapper___WHzxG",
  "carousel-scroller": "styles-module__carousel-scroller___3JcHT",
  "next-month-button": "styles-module__next-month-button___6-C3T",
  "previous-month-button": "styles-module__previous-month-button___LDLuE",
  loader: t
};
export {
  e as default,
  t as loader
};
